<template>
  <div class="row pg_sec"  v-if="data && data.length > 0">
    <div class="col-12 sec_content">
      <div class="row">
        <div class="col-12 gph_sec ace_sec" aria-label="Chart">
          <div class="bar_chart_container bar_label_inside chart_age_breakdown">
            <template v-for="(item, index) in data">
              <div class="row bar_row ace_sec">
                <div class="col-12">

                  <div class="bar_container clickable" :id="'popover_' + index">
                     <div class="bar_label">{{ item.name }} </div>
                     <div class="bar_val">{{ item.value }}</div>
                     <div class="bar" v-bind:style="{width:(item.value/100) + '%'}"></div>
                  </div>

                  <div id="chartToolTip" class="chart_tooltip_popover"></div>

                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'barChart2',
  props: ['title', 'data'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadList()
  },

  methods: {
    loadList () {
    }
  },

  computed: {
  },

  watch: {
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/BarChart2.vue